module.exports = __webpack_public_path__ + "static/tab2-5c63aa6cd41782dbc907a12929f31fc6.jpg";